import { createSlice } from '@reduxjs/toolkit'
import {getFactoryRates} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  rates: [], 
  loading: "idle",
  error: null }

const factoryRatesSlice = createSlice({
  name: 'factoryRates',
  initialState,
  reducers: {
    clearProvinceError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getFactoryRates.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryRates.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.rates = action.payload
      
    },
    [getFactoryRates.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearProvinceError} = factoryRatesSlice.actions;
export default factoryRatesSlice.reducer
